import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import BlueprintsList from './BlueprintsList';
import BlueprintDetail from './BlueprintDetail';
import BlueprintAuthoringV2 from './v2/BlueprintAuthoringV2';

/**
 * AdminDashboard > Blueprints. Ungated (all of AdminDashboard is admin-only).
 *
 *  /dashboard/blueprints                              → family list
 *  /dashboard/blueprints/:blueprintId                 → version × difficulty grid
 *  /dashboard/blueprints/:blueprintId/author/:variantId → authoring (SessionSettingsDense)
 */
const Blueprints: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <BlueprintsList />
      </Route>
      <Route exact path={`${path}/:blueprintId/author/:variantId`}>
        <BlueprintAuthoringV2 />
      </Route>
      <Route path={`${path}/:blueprintId`}>
        <BlueprintDetail />
      </Route>
      <Redirect to={`${path}`} />
    </Switch>
  );
};

export default Blueprints;
